export default "__VITE_PUBLIC_ASSET__0ab95230__"